{
  "seoTitle": "About",
  "seoDescription": "Meet Leah Harding, an Emmy-nominated former international journalist, event moderator, podcast host and strategic communications expert.",
  "seoImage": "/assets/site/leah-harding-presenter-139dc4d7.jpg",
  "hero": {
    "kicker": "About Leah",
    "headingLine1": "Curiosity is",
    "headingLine2": "her compass.",
    "portrait": {
      "src": "/assets/site/leahharding8-1493bbc9.jpg",
      "alt": "Portrait of Leah Harding",
      "focusX": 50,
      "focusY": 30
    },
    "caption": "Journalist · Moderator · Host"
  },
  "sidebar": {
    "sectionLabel": "The short version",
    "quote": "“I specialize in generalizing.”",
    "facts": [
      { "label": "Based", "value": "Washington, D.C." },
      { "label": "Languages", "value": "English, conversational Arabic" },
      { "label": "Education", "value": "University of Florida, Syracuse University" }
    ]
  },
  "body": [
    "Leah Harding is an Emmy-nominated former international journalist and host of Disengaged, an award-winning podcast now in its second season. Conversational in Arabic, Leah spent nearly a decade reporting from the Middle East, covering major events like four U.S. election cycles, the 2019 attempted coup in Ethiopia and the climate crisis from Antarctica.",
    "She likes to say she specializes in generalizing, given her wide-ranging background across multiple sectors. Her journalism career began in 2011 at WUFT-TV/FM in Gainesville, Florida, and later led her to Al Jazeera English in Doha, Qatar, where she helped launch the network’s first interactive Newshour, NewsGrid. Leah's work has earned multiple awards, including an Emmy nomination.",
    "After transitioning to strategic communications, Leah served as a policy communications consultant at Rud Pedersen Public Affairs in Brussels, helping clients navigate complex political landscapes in the EU. She currently provides media consulting for the Center for Strategic and International Studies (CSIS), supporting communications strategy and outreach.",
    "In addition to consulting, Leah is a public speaker and panel guest on self-advocacy, women’s empowerment and navigating professional transitions. She is passionate about creating supportive spaces for women in media, politics and leadership.",
    "Currently based in Washington, D.C., Leah has lived in Jordan, Ethiopia, Kenya, New Zealand and Qatar, and has visited more than 70 countries. She holds a B.S. in Telecommunication-News with a minor in Arabic Language and Literature from the University of Florida and a Master’s in Public Diplomacy and Global Communications from Syracuse University with a certificate in National Security Studies.",
    "An avid scuba diver and hiker, Leah also has a passion for animal rehabilitation and helped Fur Bae Rescue rehome over 300 abandoned dogs from Qatar during the pandemic. Her adopted Doberman, Josie, and former street cat, Jefferson, are stars on her Instagram."
  ],
  "cta": {
    "label": "Work with Leah",
    "href": "/connect"
  },
  "gallery": [
    { "src": "/assets/site/leahharding8-1493bbc9.jpg", "focusX": 50, "focusY": 40 },
    { "src": "/assets/site/leahharding1-4369f67b.jpeg", "focusX": 50, "focusY": 40 },
    { "src": "/assets/site/leahharding4-c51c5bc2.png", "focusX": 50, "focusY": 40 },
    { "src": "/assets/site/leahharding5-dbba133d.jpg", "focusX": 50, "focusY": 40 },
    { "src": "/assets/site/leahharding2-5999b48b.jpeg", "focusX": 50, "focusY": 40 },
    { "src": "/assets/site/leahharding7-e747e4b5.jpg", "focusX": 50, "focusY": 40 }
  ],
  "closingQuote": {
    "kicker": "Behind the résumé",
    "text": "A scuba diver. A hiker. An animal advocate. A woman who has lived in six countries and still believes the most interesting place is wherever the next good question leads."
  }
}
